module.exports = __webpack_public_path__ + "band_7.21c2094c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_7.png
// module id = 3CaD
// module chunks = 0